import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IBusinessExemptInspectionsViewModel, ICitations, IEnclosedAreaReportViewModel, IPostRemediationPlan, IRemediationViewModel, IResponseLettersView, ISiteVisitModel } from 'app/models/mainMenu/mainMenu';
import { ComplaintService } from 'app/services/complaint/complaint.service';
import { MainMenuService } from 'app/services/mainMenu/mainMenu.service';

@Component({
  selector: 'app-mainMenu-postRemediation',
  templateUrl: './postRemediation.component.html',
  styleUrls: ['./postRemediation.component.scss'],
  // changeDetection: ChangeDetectionStrategy.Default
})

export class PostRemediationComponent implements OnInit {
  @Input() countyId: string = '';

  postRemediationList: IPostRemediationPlan[] = [];
  citationsList: ICitations[] = [];
  annualInspectionsList: IBusinessExemptInspectionsViewModel[] = [];
  businessEnclosedList: IEnclosedAreaReportViewModel[] = [];

  displayedColumns: string[] = ['complaintId', 'businessName', 'address', 'city', 'zipCode'];
  dataSource = new MatTableDataSource<IPostRemediationPlan>(this.postRemediationList);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public mainMenu: MainMenuService,
    public complaintService: ComplaintService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    // Post Remediation
    this.mainMenu.getPostRemediationPlanVisit(this.countyId).subscribe({
      next: response => {
        this.mainMenu.postRemediationList = response;
        this.dataSource.data = this.mainMenu.postRemediationList;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Post Remediations");
      },
    });
  }

  gotoComplaint(compId: string) {
    this.complaintService.complaintId = +compId;
    this.complaintService.complaintTab = 4;
    this.complaintService.complaintVisitTab = 2;
    this.sharedService.doRedirect('complaint/complaint/' + compId);
  }


}